import React from 'react';

import Headline from 'Core/Components/Headline';
import ContentController from 'RLX/Controllers/ContentController';

class HeadlineEditor extends ContentController {
  constructor (props) {
    super(props);
  }

  static getInitialShape () {
    return {
      props: {
        text: '',
        className: '',
        wrap: false
      }
    };
  }

  shouldDisplayPreviewInline () {
    return true;
  }

  getClassName () {
    return 'HeadlineEditor';
  }

  getPreview () {
    return <Headline {...this.props.content.props} />
  }

  getFields () {
    const faded = { opacity: 0.5 };
    const { content } = this.props;
    return [
      {
        type: 'text',
        icon: 'font',
        className: 'third',
        label: 'Headline Text',
        value: content.props.text,
        onChange: this.applyUpdate((text, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, text } };
        })
      },
      {
        type: 'text',
        icon: 'css3',
        className: 'third',
        label: <span>CSS Classes <span style={faded}>(Optional)</span></span>,
        value: content.props.className,
        onChange: this.applyUpdate((className, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, className } };
        })
      },
      {
        type: 'toggle',
        icon: 'align-left',
        className: 'third',
        label: 'Auto-Wrap Text',
        value: content.props.wrap,
        onChange: this.applyUpdate((wrap, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, wrap } };
        })
      }
    ];
  };
};

export default HeadlineEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Editors/HeadlineEditor.jsx